/* Package JSON Import will be here */
import _ from "lodash";
import { push } from "connected-react-router";
/* Package JSON Import will be here */

/* Project Import will be here */
import { getErrorObject, errorToast, successToast } from "utilities/utils";
import { getSalesReturnSummaryApi, uploadSalesReturnApi, submitSalesReturnApi, clearAllSalesReturnApi } from "services/salesReturn/productSalesReturn";
import { ISalesReturnUpload } from "models/salesReturnModels";
import { showMsgFromJson } from "reducers/common";
import Constants from "utilities/appConstants";
import { appRoutesConst } from "app/navigation";
import { getTodayDateWithYearMonthDateFormat } from "utilities/utils";
import { clearHistoryFilter } from "reducers/orderHistory/historyFilter";
import { GARemoveFromSalesReturnSummary, GASubmitSalesReturnSummary } from "hooks/googleAnalyticsHooks";
/* Project Import will be here */

export const types = {
    SALES_RETURN_SUMMARY_REQUEST: "salesReturnProducts/SALES_RETURN_SUMMARY_REQUEST",
    SALES_RETURN_SUMMARY_SUCCESS: "salesReturnProducts/SALES_RETURN_SUMMARY_SUCCESS",
    SALES_RETURN_SUMMARY_FAILURE: "salesReturnProducts/SALES_RETURN_SUMMARY_FAILURE",
    SALES_RETURN_UPLOAD_REQUEST: "salesReturnProducts/SALES_RETURN_UPLOAD_REQUEST",
    SALES_RETURN_UPLOAD_SUCCESS: "salesReturnProducts/SALES_RETURN_UPLOAD_SUCCESS",
    SALES_RETURN_UPLOAD_FAILURE: "salesReturnProducts/SALES_RETURN_UPLOAD_FAILURE",
    CLEAR_SALES_RETURN_SUMMARY: "salesReturnProducts/CLEAR_SALES_RETURN_SUMMARY",
    SALES_RETURN_SUBMIT_REQUEST: "salesReturnProducts/SALES_RETURN_SUBMIT_REQUEST",
    SALES_RETURN_SUBMIT_FAILURE: "salesReturnProducts/SALES_RETURN_SUBMIT_FAILURE"
};

const initialState = {
    isLoading: false,
    isSubmitLoading: false,
    data: [],
    error: null,
    returnUpload: {
        isLoading: false,
        error: null,
    }
};
export const salesReturnSummary = (state = initialState, action) => {
    switch (action.type) {
        case types.SALES_RETURN_SUMMARY_REQUEST:
            return {
                ...state,
                isLoading: true
            };
        case types.SALES_RETURN_SUMMARY_SUCCESS:
            return {
                ...state,
                ...action.payload,
                error: null,
                isLoading: false
            };
        case types.SALES_RETURN_SUMMARY_FAILURE:
            return {
                ...state,
                data: [],
                isLoading: false,
                error: action.payload.error
            };
        case types.SALES_RETURN_UPLOAD_REQUEST:
            return {
                ...state,
                returnUpload: {
                    ...state.returnUpload,
                    isLoading: true
                }
            };
        case types.SALES_RETURN_UPLOAD_SUCCESS:
            return {
                ...state,
                returnUpload: {
                    ...state.returnUpload,
                    isLoading: false,
                    error: null
                }
            };
        case types.SALES_RETURN_UPLOAD_FAILURE:
            return {
                ...state,
                returnUpload: {
                    ...state.returnUpload,
                    isLoading: false,
                    error: action.payload.error
                }
            };
        case types.CLEAR_SALES_RETURN_SUMMARY:
            return {
                ...initialState
            };
        case types.SALES_RETURN_SUBMIT_REQUEST:
            return {
                ...state,
                isSubmitLoading: true
            };
        case types.SALES_RETURN_SUBMIT_FAILURE:
            return {
                ...state,
                isSubmitLoading: false
            };
        default:
            return state;
    }
};

/* Get product list based on the applied filer conditions */
export const getSalesReturnSummary = () => {
    return async (dispatch, getState) => {
        let isShowSalesReturn: Boolean = getState().appSettings.isShowSalesReturn;
        if (isShowSalesReturn) {
            dispatch({ type: types.SALES_RETURN_SUMMARY_REQUEST });
            try {
                /* get sales return products with the applied filter conditions */
                const response = await getSalesReturnSummaryApi();

                dispatch({
                    type: types.SALES_RETURN_SUMMARY_SUCCESS,
                    payload: {
                        data: response.data.Data
                    }
                });
            }
            catch (error) {
                dispatch(promiseCatchBlock(error, types.SALES_RETURN_SUMMARY_FAILURE));
            }
        }
    }
};


/* Clear all sales return summary items */
export const clearSalesReturnSummary = () => {
    return async (dispatch, getState) => {
        dispatch({
            type: types.SALES_RETURN_UPLOAD_REQUEST,
            payload: { deleteLoading: false, deleteAllLoading: true }
        });
        try {
            /* GA - Track remove sales return summary event - Take product list before clear*/
            const products = getState().salesReturnSummary.data;

            /* Trigger API to remove the deleted cart product from database */
            await clearAllSalesReturnApi();

            /* Display the success toast message */
            dispatch(showMsgFromJson("common.alerts.success.clearAllSalesReturnSummary", Constants.SUCCESS));

            dispatch({ type: types.SALES_RETURN_UPLOAD_SUCCESS });
            dispatch(getSalesReturnSummary());
            dispatch(push(appRoutesConst.salesReturn));

            /* GA - Track remove sales return summary event */
            if (window.isEnableGA)
                GARemoveFromSalesReturnSummary(products);
        }
        catch (error) {
            const { message } = getErrorObject(error);
            dispatch({
                type: types.SALES_RETURN_UPLOAD_FAILURE,
                payload: { error: message }
            });
        }
    };
};

export const deleteSalesReturnItem = (productItem) => {
    return async (dispatch, getState) => {
        dispatch({ type: types.SALES_RETURN_UPLOAD_REQUEST });
        try {
            /* Form the uploadSalesReturn API request array */
            let requestDataList = [];

            /* Loop the dynamic reason master data and form the array */
            _.forEach(productItem.Reasons, o => {
                let requestData: ISalesReturnUpload = {
                    MfgDate: getTodayDateWithYearMonthDateFormat(),
                    PId: productItem.ProductId,
                    PName: productItem.ProductName,
                    PrincipalId: productItem.PrincipalId,
                    Qty: 0,
                    Reason: o.ReasonName,
                    ReasonId: o.ReasonId,
                    UomId: productItem.UomId
                }
                requestDataList.push(requestData)
            });
            await uploadSalesReturnApi(requestDataList);

            /* Response toast message */
            dispatch(showMsgFromJson(`store.products.successMessages.productDeleted`, Constants.SUCCESS));
            dispatch({ type: types.SALES_RETURN_UPLOAD_SUCCESS });

            /* Reload the sales return summary when only the data is changed */
            dispatch(getSalesReturnSummary());

            /* GA - Track remove sales return summary event */
            if (window.isEnableGA)
                GARemoveFromSalesReturnSummary(requestDataList);
        }
        catch (error) {
            dispatch(promiseCatchBlock(error, types.SALES_RETURN_UPLOAD_FAILURE));
        }
    }
}

/* Upload the sales QTY */
export const uploadReturnQty = (productDetails, QtyDetails) => {
    return async (dispatch, getState) => {
        dispatch({ type: types.SALES_RETURN_UPLOAD_REQUEST });
        try {
            /* Form the uploadSalesReturn API request array */
            let requestDataList: List<ISalesReturnUpload> = [];

            /* Loop the dynamic reason master data and form the array */
            _.forEach(QtyDetails, o => {
                let qtyCount = o.selectedPieceQty;
                /* Check for case qty added */
                if (o.selectedCaseQty > 0) {
                    qtyCount = qtyCount + (productDetails.ConversionQty * o.selectedCaseQty)
                }
                let requestData: ISalesReturnUpload = {
                    MfgDate: getTodayDateWithYearMonthDateFormat(),
                    PId: productDetails.ProductId,
                    PName: productDetails.ProductName,
                    PrincipalId: productDetails.PrincipalId,
                    Qty: qtyCount,
                    Reason: o.reasonName,
                    ReasonId: o.reasonId,
                    UomId: productDetails.UomId
                }
                requestDataList.push(requestData)
            });

            const response = await uploadSalesReturnApi(requestDataList);

            /* Response toast message */
            if (response.data.Code)
                dispatch(showMsgFromJson(`common.alerts.success.${response.data.Code}`, Constants.SUCCESS));
            else
                successToast({ content: response.data.Msg });

            dispatch({ type: types.SALES_RETURN_UPLOAD_SUCCESS });

            /* Reload the sales return summary when only the data is changed */
            dispatch(getSalesReturnSummary());
        }
        catch (error) {
            dispatch(promiseCatchBlock(error, types.SALES_RETURN_UPLOAD_FAILURE));
        }
    }
};

/* SUbmit the over all return result functionality */
export const submitSalesReturn = (invoiceNo, remark) => {
    return async (dispatch, getState) => {
        try {
            /* To display loader once confirmed the order */
            dispatch({ type: types.SALES_RETURN_SUBMIT_REQUEST });

            let requestData: ISalesReturnSubmit = {
                Invoice: invoiceNo,
                Remarks: remark
            }

            const response = await submitSalesReturnApi(requestData);

            if (response.data.Code)
                dispatch(showMsgFromJson(`common.alerts.success.${response.data.Code}`, Constants.SUCCESS));
            else
                successToast({ content: response.data.Msg });

            /* Clear sales return summary after successful order */
            dispatch({ type: types.CLEAR_SALES_RETURN_SUMMARY });

            /* Navigate the user to the salesReturnHistory page after the successful transaction */
            await dispatch(clearHistoryFilter());
            dispatch(push(appRoutesConst.salesReturnHistory));

            /* GA - Track submitted sales return summary SRH Number details */
            if (window.isEnableGA)
                GASubmitSalesReturnSummary(response.data.Data[0].SRH_No);
        }
        catch (error) {
            /* Extract the error message and error code from the response object */
            const { message, errorCode } = getErrorObject(error);

            dispatch({ type: types.SALES_RETURN_SUBMIT_FAILURE });
            /* If error code is exist show the error code message or show the error message returned by the API request */
            if (errorCode !== "")
                dispatch(showMsgFromJson(`common.alerts.error.${errorCode}`, Constants.ERROR));
            else
                errorToast({ content: message });
        }
    }
};

/* Generic code for promise catch block */
const promiseCatchBlock = (error: any, type: string) => {
    return (dispatch) => {
        const { message } = getErrorObject(error);
        dispatch({
            type: type,
            payload: { error: message }
        });
    }
};